<template>
      <div>
        <strong>Countries</strong>: {{ defineCountries(this.countries) }}.
      </div>
</template>

<script>
export default {
  name: 'RecipeCountry',
  props: {
    index: Number,
    countries: Array
  },
  methods: {
    defineCountries (countries) {
      if ( countries && (countries.length !== 0)) {
        if (countries.includes('Other') && countries.length !== 1) {
          let index = countries.indexOf('Other')
          countries.splice(index, 1)
        }
        return countries.join(', ')
      } else {
        return 'No countries have been specified'
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/recipes/RecipeCountry.vue